import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MessageContentProps {
  isUser: boolean;
  text: string;
}

export const MessageContent: React.FC<MessageContentProps> = ({
  isUser,
  text,
}) => {
  if (isUser) {
    return <p className="font-light">{text}</p>;
  }

  const components: {
    [nodeType: string]: React.ComponentType<{
      children: React.ReactNode;
      [key: string]: any;
    }>;
  } = {
    p: ({ children }) => (
      <p className="font-light text-neutral-700 my-2">{children}</p>
    ),
    h1: ({ children }) => (
      <h1 className="text-sm font-semibold my-4 text-neutral-900">
        {children}
      </h1>
    ),
    h2: ({ children }) => (
      <h2 className="text-sm font-semibold my-3 text-neutral-900">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="text-sm font-semibold my-3 text-neutral-900">
        {children}
      </h3>
    ),
    h4: ({ children }) => (
      <h4 className="text-sm font-medium my-2 text-neutral-900">{children}</h4>
    ),
    h5: ({ children }) => (
      <h5 className="text-xs font-medium my-1 text-neutral-900">{children}</h5>
    ),
    h6: ({ children }) => (
      <h6 className="text-xs font-medium my-1 text-neutral-900">{children}</h6>
    ),
    ul: ({ children }) => (
      <ul className="list-disc pl-5 my-2 text-neutral-800">{children}</ul>
    ),
    ol: ({ children }) => (
      <ol className="list-decimal pl-5 my-2 text-neutral-800">{children}</ol>
    ),
    li: ({ children }) => <li className="my-1 font-light">{children}</li>,
    strong: ({ children }) => (
      <span className="font-normal text-neutral-900">{children}</span>
    ),
    hr: () => <hr className="my-4 border-neutral-200" />,
  };

  return (
    <div className="markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {text}
      </ReactMarkdown>
    </div>
  );
};
